import React from 'react';

import styled from '@ihme/common/theme/styled';

type Props = {
    children: any;
};

const Container = styled.div(({ theme }) => ({
    marginTop: 48,
    marginBottom: 50,
}));

const PageHeader = (props: Props) => (
    <Container>
        <div className="subpage__title">{props.children}</div>
    </Container>
);

export default PageHeader;
